import axiosVirdioT from '../utils/axios';
import SessionDataStore from "../streaming/SessionDataStoreController";
import Util from "../streaming/Util";
var axiosVirdio = new axiosVirdioT(); 

const openLiveClass = function(classId, isOnDemand) {
	console.log('openLiveClass---1', classId, isOnDemand);
	var sessionDataStoreVar = SessionDataStore.getInstance();
	console.log('openLiveClass---2');
	let userData = JSON.parse(localStorage.getItem('userData'));
	console.log('openLiveClass---3', userData);
    let token = userData.token;
	console.log('openLiveClass---4', token);
	
	let url = "individualsessiondetail";
	if ( isOnDemand ) { url = "individualSessionDetailOndemand"; }
	console.log('openLiveClass---5', url);
    let addObject = {"sessionId": classId,  "userId": userData.id, "event": "status", "eventType": "joinSession", "details": JSON.stringify({"msg": "Join Class button clicked on Class listing page"}), "timestamp": Util.getCurrentTimestamp()};
    sessionDataStoreVar.addSessionData(addObject);
	console.log('openLiveClass---6');
	axiosVirdio.auth(token);
	console.log('openLiveClass---7');
	axiosVirdio.get(process.env.REACT_APP_API_URL+"/api/v1/session/"+classId+"/"+url).then(res => {
	console.log('openLiveClass---8', res);
		
		let sessionDetail = JSON.stringify(res.data.responseData);
	console.log('openLiveClass---9', sessionDetail);
		let sessionDetail1 = JSON.parse(sessionDetail);
		sessionDetail1.token = token;
        sessionDetail1.unmuteAllEnabled = false;
		console.log('sessionDetail1', sessionDetail1);
		console.log('classId', classId);
		let settingsInSession = JSON.parse(localStorage.getItem('settingsInSession'));
		if ( settingsInSession )
			{
				if ( settingsInSession['sessionId'] == sessionDetail1['sessionData']['id'] )
					{
						sessionDetail1['sessionData']['StartRecordSession'] = settingsInSession['StartRecordSession'];
						sessionDetail1['sessionData']['StartMusicSession'] = settingsInSession['StartMusicSession'];
						sessionDetail1['sessionData']['showOtherParticipants'] = settingsInSession['showOtherParticipants'];
						sessionDetail1['sessionData']['CustomResolutionHigh'] = settingsInSession['CustomResolutionHigh'];
						sessionDetail1['sessionData']['switchHostParticipant'] = settingsInSession['switchHostParticipant'];
						sessionDetail1['sessionData']['disableNotificationSound'] = settingsInSession['disableNotificationSound'];
						sessionDetail1['sessionData']['calculateAssessmentDimensions'] = settingsInSession['calculateAssessmentDimensions'];
						sessionDetail1['sessionData']['turnoffRoomSetup'] = settingsInSession['turnoffRoomSetup'];
					}
				else
					{
						localStorage.removeItem('settingsInSession');
					}
			}
		if ( userData.channelSettings )
			{
				sessionDetail1['channelSettings'] = userData.channelSettings;
			}
			
		if ( userData['sessionData'] && (userData['sessionData'].hasRecording != undefined || userData['sessionData'].hasRecording != null) )
			{
				sessionDetail1['sessionData']['hasRecording'] = userData['sessionData']['hasRecording'];
			}
		
		if ( isOnDemand ) { sessionDetail1.userType = 2; }
		
		localStorage.setItem("userData", JSON.stringify(sessionDetail1));
		this.props.history.push("/pre-screen");
	}).catch( err => { 
		let addObject = {"sessionId": classId,  "userId": userData.id, "event": "error", "eventType": "joinSession", "details": JSON.stringify({"msg": "Error in getting class details on Class listing page", "err": err}), "timestamp": Util.getCurrentTimestamp()};
		sessionDataStoreVar.addSessionData(addObject);
	});
}


export { openLiveClass } 